export default __webpack_public_path__ + "static/media/Figma logo.afc0d9a3.svg";